import cn from 'classnames';
/* Class assignment */
export var formFieldClass = function (className, isFullWidth) { return cn(className, 'flex flex-col', isFullWidth && 'w-full'); };
